import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import useToaster from 'utils/hooks/useToaster';
import EnhetApi from 'services/KjederegisteretAdminApi/EnhetApi';
import { EnhetViewModel } from 'services/KjederegisteretAdminApi/EnhetApi/types';
import HttpErrorHelper from 'utils/HttpErrorHelper';
import CommonLoader from 'components/CommonLoader';

interface Props {
  enhetId: number;
  name: string;
  show: boolean;
  handleClose: () => void;
  onFeilOpprettet: (enhet: EnhetViewModel) => void;
}

const FeilOpprettetModal = (props: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const toaster = useToaster();

  const markerSomFeilOpprettet = async () => {
    setIsLoading(true);
    try {
      const e = await EnhetApi.markerSomFeilOpprettet(props.enhetId);
      props.onFeilOpprettet(e);
      toaster.success('Suksess!', 'Enheten er markert som feil opprettet.');
      props.handleClose();
    } catch (err) {
      toaster.error(
        'Feil! Kunne ikke markere som feil opprettet.',
        HttpErrorHelper.formatError(err),
      );
    }
    setIsLoading(false);
  };

  return (
    <Modal show={props.show} onHide={props.handleClose}>
      <Modal.Header>
        <Modal.Title>Feil opprettet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Enheten ved navn {props.name} legges ned fra oppstartsdato og kommer ut som nedlagt i API.
        </p>
        <p className="mb-0">
          Kontaktinfo, GLN, juridisk navn, adresser, grossistkoblinger og leverandørkundenumre
          fjernes. Orgnr og besøksadresse settes til Tradesolution sitt.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={isLoading} variant="secondary" onClick={() => props.handleClose()}>
          Avbryt
        </Button>
        <Button disabled={isLoading} variant="danger" onClick={() => markerSomFeilOpprettet()}>
          {isLoading && (
            <span className="mr-2">
              <CommonLoader />
            </span>
          )}
          <span>{isLoading ? 'Lagrer' : 'Feil opprettet'}</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeilOpprettetModal;
